/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

import { IMAGE_VIEWS, sortByCreatedDate } from '@/constants'

export const defaultContextMenu = {
  id: null,
  x: 0,
  y: 0,
}

const NUMBER_OF_COLUMNS = 7

const getDefaultColumnFields = (firstColumn = false) => ({
  filtersForServer: {},
  filtersForUI: {
    gridSize: firstColumn ? 4 : 1,
    imageViewType: IMAGE_VIEWS.regular,
    order: sortByCreatedDate.desc,
    showAsideFilters: false,
    showColumn: firstColumn || false,
    showNumbers: true,
    showOptions: true,
    showTags: true,
  },
  imageList: [],
  loading: false,
  page: 1,
  totalImagesFiltered: 0,
  totalImagesNew: 0,
})

export const getDefaultColumns = () => [...Array(NUMBER_OF_COLUMNS)].map((_, index) => ({
  ...getDefaultColumnFields(index === 0),
  id: index + 1,
}))

export default {
  columns: getDefaultColumns(),
  columnsDialogVisibility: false,
  contextMenu: { ...defaultContextMenu },
  currentRace: {},
  currentComparesImages: [],
  currentBaselineComparesImages: [],
  isShowComparesFooter: false,
  ordered: sortByCreatedDate.desc,
  pollingImages: {
    columns: [],
    id: null,
  },
  savedRaces: {}
}
